import { render, staticRenderFns } from "./CandidateDetailsTalentfindNew.vue?vue&type=template&id=50410990&scoped=true"
import script from "./CandidateDetailsTalentfindNew.vue?vue&type=script&lang=js"
export * from "./CandidateDetailsTalentfindNew.vue?vue&type=script&lang=js"
import style0 from "./CandidateDetailsTalentfindNew.vue?vue&type=style&index=0&id=50410990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50410990",
  null
  
)

export default component.exports